import { useOnboardingStore } from '../../../store/onboardingStore';

const truncateWords = (text: string, wordCount: number) => {
  if (!text) return '';
  const words = text.split(' ');
  if (words.length <= wordCount) return text;
  return words.slice(0, wordCount).join(' ') + '...';
};

export function ProductCard() {
  
  const { data } = useOnboardingStore();
  const { productData, visualContent } = data;

  // Get the product image or a placeholder
  const productImage = visualContent.images.length > 0 
    ? visualContent.images[0] 
    : visualContent.imagesBase64.length > 0
      ? visualContent.imagesBase64[0]
      : 'https://placehold.co/400x400/e2e8f0/64748b?text=No+Image';

  const truncatedDetails = productData.details && productData.details.length > 100 
    ? `${productData.details.substring(0, 100)}...` 
    : productData.details;

  return (
    <div className="bg-white border border-gray-200 rounded-lg p-3 shadow-sm">
      <div className="flex items-center space-x-3">
        <div className="flex-shrink-0 w-14 h-14 rounded-md overflow-hidden bg-gray-100">
          <img 
            src={productImage} 
            alt={productData.name || "Product"} 
            className="w-full h-full object-cover"
          />
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center justify-between">
            <h3 className="text-base font-medium text-gray-900 truncate">
              {truncateWords(productData.name, 8)}
            </h3>
          </div>
          <p className="text-xs text-gray-500 line-clamp-1 mt-0.5">
            {truncateWords(truncatedDetails, 15)}
          </p>
        </div>
      </div>
    </div>
  );
}